module.exports = __webpack_public_path__ + "static/media/override@2x.d63d64d6.svg";